export const GET_EXPENSES_REQUEST = "GET_EXPENSES_REQUEST";
export const GET_EXPENSES_RESPONSE = "GET_EXPENSES_RESPONSE";

export const ADD_EXPENSE_REQUEST = "ADD_EXPENSE_REQUEST";

export const EDIT_EXPENSE_REQUEST = "EDIT_EXPENSE_REQUEST";

export const GET_EXPENSE_DETAILS_REQUEST = "GET_EXPENSE_DETAILS_REQUEST";
export const GET_EXPENSE_DETAILS_RESPONSE = "GET_EXPENSE_DETAILS_RESPONSE";

export const DELETE_EXPENSE_REQUEST = "DELETE_EXPENSE_REQUEST";

export const GET_MIMAR_PROFIT_REQUEST = "GET_MIMAR_PROFIT_REQUEST";
export const GET_MIMAR_PROFIT_RESPONSE = "GET_MIMAR_PROFIT_RESPONSE";